import { AuthTokenCache } from '../authentication/authTokenCache';
import teamsAuthService from './teamsAuthService';
import webAuthService from './webAuthService';

let cacheInstance: AuthTokenCache | null = null;

export const getTokenCache = (): AuthTokenCache => {
    if (!cacheInstance) {
        const authService = window.top !== window.self ? teamsAuthService : webAuthService;
        cacheInstance = new AuthTokenCache(authService);
    }
    return cacheInstance;
};

// Utile per logout o reset
export const clearTokenCache = (): void => {
    if (cacheInstance) {
        cacheInstance.clearCache();
    }
    cacheInstance = null;
};